import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["HelpSidebar"] */ "/app/components/help/help-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppTourProvider"] */ "/app/components/help/tour-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarProvider"] */ "/app/components/ui/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DebugPanelProvider"] */ "/app/lib/debug-panel-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalSettingsProvider"] */ "/app/lib/global-settings-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalStateProvider"] */ "/app/lib/modal-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OnboardingProvider"] */ "/app/lib/onboarding-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TourProvider"] */ "/app/lib/tour-context.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"inter\"}");
